export const STUDENT_REFUNDABLE = 'studentRefundable'
export const RELATION_REFUNDABLE = 'relationshipRefundable'
